<template>
    <div class="form__buttons">
        <div class="columns ">
            <div class="column custom--line "></div>
            <template v-if="secondaryButtonActive">
                <div class="column custom--block is-narrow">
                    <component-button
                        v-if="secondaryButtonActive"
                        :theme="'default'"
                        :border="true"
                        @click="secondary"
                        :name="'form-buttons-secondary'"
                    >{{secondaryButtonText}}
                    </component-button>
                </div>
            </template>
            <template v-if="primaryButtonActive">
                <div class="column custom--block is-narrow">
                    <component-button
                        :theme="'primary'"
                        @click="primary"
                        :name="'form-buttons-primary'"
                    >{{primaryButtonText}}
                        </component-button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
export default {
  name: 'form-buttons',
  components: {
    ComponentButton
  },
  props: {
    secondaryButtonActive: {
      type: Boolean,
      default: true
    },
    secondaryButtonText: {
      type: String,
      required: true
    },
    primaryButtonActive: {
      type: Boolean,
      default: true
    },
    primaryButtonText: {
      type: String,
      required: true
    }
  },
  methods: {
    secondary: function () {
      this.$emit('emit-secondary')
    },
    primary: function () {
      this.$emit('emit-primary')
    }
  }
}
</script>
